import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { Theme } from "@mui/material"
import { SxProps } from "@mui/system"
import { LOCALES } from "app/language/model"

export const DEFAULT_MESSAGE_DURATION = 5000
export const CONFIRM_BUTTON_ID = "confirm-message-confirm-button"

export const enum JAPP_MESSAGE_SEVERITIES {
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error"
}

export interface IAppMessage {
  id: string
  text: string | string[]
  severity: JAPP_MESSAGE_SEVERITIES
  duration: number | null
}

export interface IAppOverlayMessage {
  id: string
  text: string | string[]
}

export interface IAppConfirmMessage {
  icon?: IconDefinition
  message: string | string[]
  title: string
  addGenericConfirmMessage?: boolean
  isInputMessage?: boolean
  isInputPassword?: boolean
  isInputOptional?: boolean
  inputPlaceholder?: string
  confirmButtonLabel?: string
  cancelButtonLabel?: string
  hideCancelButton?: boolean
  locale?: LOCALES
  children?: JSX.Element
  isWarning?: boolean
  sx?: SxProps<Theme>
  defaultInputValue?: string
  onSuccess: (input: string) => any
  onCancel?: () => any
  /**
   * Validate input data
   * If return a non empty string, this is the validation error, displayed as it, and disable confirm button
   * @param value
   * @returns Nothing if correct, the error to display else
   */
  validateInput?: (value: string) => string | undefined
  /**
   * If promise reject, generic error message will be displayed
   * @param value input value
   * @returns not empty string if an error occured
   */
  onSuccessValidation?: (value: string) => Promise<string>
}

export interface IAppMessageOptions {
  severity?: JAPP_MESSAGE_SEVERITIES
  duration?: number | null
}

export interface IAppMessageState {
  messages: IAppMessage[]
  overlayMessages: IAppOverlayMessage[]
  confirmMessage: IAppConfirmMessage | undefined
}

export interface IAppMessageService {
  error(message: string | string[], options?: IAppMessageOptions): void
  warning(message: string | string[], options?: IAppMessageOptions): void
  info(message: string | string[], options?: IAppMessageOptions): void
  success(message: string | string[], options?: IAppMessageOptions): void
  confirmMessage(params: IAppConfirmMessage): void
  display(message: string | string[], options?: IAppMessageOptions): void
  displayWaitingOverlay(message: string | string[]): string
  closeWaitingOverlay(messageId?: string | string[]): void
}
